import '../../sass/general/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useMemo, useState } from 'react'
import RegisterBlock from '../../components/Registraion/RegisterBlock';
import { ReactComponent as CleanTalkLogo } from '../../svg/filled/cleantalklogo.svg';
import { ReactComponent as CleanTalkLogoText } from '../../svg/cleantalklogo-text.svg';
import Select, { components } from 'react-select';
import { CUSTOM_BILLS_ID, FEATURED_PRODUCTS_PAIR } from '../../constants/constants'
import { ReactComponent as ChevronDown } from '../../svg/chevron-down.svg';
import { connect } from 'react-redux';
import {
    productAvailableAccountsSelector,
    productCurrentProductIdSelector,
    productsMainProductsSelector,
} from '../../redux/selectors/productSelector'
import {
    fetchPaymentMenu, saveKey,
    saveProductId,
    setAccountFormIsVisible, setCustomBills
} from '../../redux/actions/pagesActions'
import { ToastContainer, Bounce } from 'react-toastify';
import init from '../init';
import Footer from '../../components/Footer/Footer';
import useQuery from '../../hooks/useQuery';
import { setCartSelectedBills, setPeriodFromQuery, setTariffFromQuery } from '../../redux/actions/cartAction'
import {
    accountFormIsVisible,
    pageLoading,
    pagesTariffsSelector,
    paymentMenu
} from '../../redux/selectors/pagesSelectors'
import Skeleton from 'react-loading-skeleton';
import TotalBill from '../../components/TotalBill';
import ReactModal from "react-modal";
import RegisterForm from "../../components/Registraion/RegisterForm";
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useHeaderSlot } from '../../context/HeaderSlotContext'

function Main({
    mainProductId,
    setProductId,
    accountsList,
    setPeriod,
    setTariff,
    mainProduct,
    pageLoading,
    pagesTariffs,
    registrationFormIsVisible,
    setFormIsVisible,
    setPaymentMenu,
    setCustomBills,
    setCartSelectedBills,
    saveKey
}) {
    // Init stands to a single entry point with a dedicated functional script(s)
    // start-up actions execution (like setting up "page opened" cookie).
    useEffect(() => {
        init({ mainProductId });
    }, [mainProductId]);

    const query = useQuery();

    useEffect(() => {
        const userToken = query.get('user_token') ?? null;
        const paymentPageToken = query.get('payment_page_token') ?? null;
        if (userToken || paymentPageToken) {
            saveKey(userToken, paymentPageToken);
        }
    }, [query, saveKey]);

    const navigate = useNavigate();

    let baseOptions = useMemo(() => {
        const options = [];
        for (const i in FEATURED_PRODUCTS_PAIR) {
            if (!!FEATURED_PRODUCTS_PAIR[i].allowedAsSeparate) {
                options.push({
                    value: isNaN(Number(i)) ? i : +i,
                    label: FEATURED_PRODUCTS_PAIR[i].name,
                    description: FEATURED_PRODUCTS_PAIR[i].description,
                    isDisabled: !FEATURED_PRODUCTS_PAIR[i].active,
                });
            }
        }

        return options;
    }, []);

    const [filteredOptions, setFilteredOptions] = useState([]);
    const [optionItem, setOptionItem] = useState(null);
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const { headerContent } = useHeaderSlot();

    useEffect(() => {

        if (baseOptions.length > 0) {

            setPaymentMenu().then((data) => {
                const bills = data?.custom_bills;
                let updatedOptions= baseOptions;
                // Remove custom bill menu if no bills exist
                if (!bills?.bills || bills.bills.length === 0)  {
                    updatedOptions = baseOptions?.filter((option) => {
                        return (option.value !== CUSTOM_BILLS_ID);
                    });
                }
                setCustomBills(bills);
                setFilteredOptions(updatedOptions);
            });

        }
    }, [baseOptions, setCustomBills, setPaymentMenu]);

    // On initial page load, select a menu.
    useEffect(() => {
        const productParamId = searchParams.get('product_id');

        if (location.pathname.startsWith('/bills')) {
            setOptionItem(filteredOptions.find(opt => opt.value === CUSTOM_BILLS_ID) ?? {});
            return
        }

        if (productParamId) {
            setOptionItem(filteredOptions.find(opt => opt.value === +productParamId) ?? {});
        }

        setCartSelectedBills({});
    }, [filteredOptions, location.search, location.pathname, searchParams, setCartSelectedBills]);


    const Option = (props) => {
        return (
            <components.Option {...props}>
                <div>
                    <p className={'title'}>{props.data.label}</p>
                    <p className={'description'}>{props.data.description}</p>
                </div>
            </components.Option>
        );
    };

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <ChevronDown className={'icon'} />
            </components.DropdownIndicator>
        );
    };

    useEffect(() => {
        if (
            accountsList?.find((item) => +item.account_id === +query.get('account'))?.trial &&
            +query.get('product_id') === 7
        ) {
            setPeriod({
                period: 'Month',
                interval: '1',
            });
        }
    }, [accountsList, query, setPeriod]);

    useEffect(() => {
        if (!mainProduct || !mainProduct.valid_till) return;
        if(!query.get('tariff_id') && mainProduct.valid_till){
            const date = new Date()
            if(new Date(mainProduct.valid_till) > date){
                if(((new Date(mainProduct.valid_till) - date)/ (1000 * 60 * 60 * 24)) <= 30){
                    setTariff({tariff_id:mainProduct.current_tariff_id})
                } else {
                    const tariffsLimited = Object.values(pagesTariffs)?.filter(item => +item.product_id === +mainProduct.product_id && item?.services !== 0).sort((a,b) => a.cost - b.cost);
                    const tariffsUnlimited = Object.values(pagesTariffs)?.filter(item => +item.product_id === +mainProduct.product_id && item?.services === 0).sort((a,b) => a.cost - b.cost);
                    const tariffs = tariffsLimited.concat(tariffsUnlimited);
                    const currentTariffIndex = tariffs.map(item => +item.tariff_id).indexOf(+mainProduct.current_tariff_id);
                    if(currentTariffIndex+1 <= tariffs.length){
                        setTariff({tariff_id:`${tariffs[currentTariffIndex+1].tariff_id}`})
                    } else {
                        setTariff({tariff_id:`${mainProduct.current_tariff_id}`})
                    }
                }
            } else {
                setTariff({tariff_id:mainProduct.current_tariff_id})
            }
        }
    }, [mainProduct, pagesTariffs, query, setTariff]);

    return (
        <>
          {/*  <CTaskQueryParameter />*/}
            <header className="header">
                <div className="container mobile-side-gap header__container">
                    <a className={'header__logo-link'} href="https://cleantalk.org/my">
                        <CleanTalkLogo className={'header__logo-icon'} />
                        <CleanTalkLogoText className={'header__logo-text icon'} />
                    </a>
                    {headerContent || (
                        <div className="header__left">
                            <div className={'relative filter__wrapper--product'}>
                                {pageLoading ? (
                                    <Skeleton
                                        width={200}
                                        height={32}
                                        inline={true}
                                        containerClassName={'mr-13'}
                                    />
                                ) : (
                                    <>
                                        <label
                                            htmlFor="categoryList"
                                            className={'filter__label filter__label--product text-5'}
                                        >
                                            Product
                                        </label>
                                        <Select
                                            id={'productList'}
                                            options={filteredOptions}
                                            className={
                                                'filter__selector ml-2 mr-16 tablet-mr-2 product-selector filter__selector--product'
                                            }
                                            classNamePrefix="filter"
                                            isSearchable={false}
                                            components={{
                                                DropdownIndicator,
                                                Option,
                                            }}
                                            onChange={(e) => {
                                                ///setSelectedId(e.value);
                                                setOptionItem(e)
                                                if (e.value === "custom_bills") {
                                                    navigate('/bills', { replace: false });
                                                    return
                                                }

                                                setProductId(isNaN(Number(e.value)) ? e.value : Number(e.value));

                                                navigate('/', { replace: false })
                                            }}
                                            isOptionDisabled={(option) => option?.isDisabled}
                                            defaultValue={optionItem}
                                            value={optionItem}
                                        />
                                    </>
                                )}
                            </div>
                            <RegisterBlock />
                            <TotalBill />
                        </div>
                        )}
                </div>
            </header>
            <main className="main">
                <Outlet />
            </main>
            <Footer />
            <ToastContainer
                position="bottom-center"
                autoClose={8000}
                hideProgressBar={true}
                stacked={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <ReactModal
                isOpen={registrationFormIsVisible}
                contentLabel="onRequestClose Example"
                onRequestClose={() => setFormIsVisible(false)}
                shouldCloseOnOverlayClick={false}
                portalClassName={'modal__container'}
                overlayClassName={'modal__overlay'}
                className={'modal__content'}
                bodyOpenClassName={'body--modal-opened'}
                htmlOpenClassName={'html--modal-opened'}
                ariaHideApp={false}
                closeTimeoutMS={500}
            >
                <RegisterForm />
            </ReactModal>
        </>
    );
}

const mapStateToProps = (state) => ({
    mainProductId: productCurrentProductIdSelector(state),
    accountsList: productAvailableAccountsSelector(state),
    mainProduct: productsMainProductsSelector(state),
    pageLoading: pageLoading(state),
    pagesTariffs: pagesTariffsSelector(state),
    registrationFormIsVisible: accountFormIsVisible(state),
    paymentMenu: paymentMenu(state),
});

const mapDispatchToProps = (dispatch) => ({
    setProductId: (data) => dispatch(saveProductId(data)),
    setPeriod: (data) => dispatch(setPeriodFromQuery(data)),
    setTariff: (data) => dispatch(setTariffFromQuery(data)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setPaymentMenu: () => dispatch(fetchPaymentMenu()) ,
    setCustomBills: ((data)=> dispatch(setCustomBills(data))),
    setCartSelectedBills: (value) => dispatch(setCartSelectedBills(value)),
    saveKey: (userToken, paymentPageToken) => dispatch(saveKey(userToken, paymentPageToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
